<div class="form-bg-wrapper py-5 px-3 px-md-4 mb-5">
    <div class="form-container mx-auto bg-white rounded-4 border p-4 p-md-5 shadow-sm">

        <header class="mb-4 d-flex justify-content-between align-items-center">
            <div>
                <h1 class="h4 fw-bold text-dark-navy mb-1 font-inter-bold">Verification Details</h1>
                <p class="text-secondary small mb-0">View historical company verification details and assessment info</p>
            </div>
        </header>

        <form [formGroup]="verificationForm" novalidate class="mb-5">
            <div class="row g-4">

                <!-- Company Name -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Company Name</label>
                    <input type="text" class="form-control" formControlName="companyName" placeholder="-">
                </div>

                <!-- Company Type -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Company Type</label>
                    <input type="text" class="form-control" formControlName="companyType" placeholder="-">
                </div>

                <!-- Registered Address -->
                <div class="col-12">
                    <label class="form-label small fw-semibold text-dark">Registered Address</label>
                    <input type="text" class="form-control" formControlName="registeredAddress" placeholder="-">
                </div>

                <!-- Country -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Country</label>
                    <input type="text" class="form-control" formControlName="country" placeholder="-">
                </div>

                <!-- Website -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Website</label>
                    <input type="text" class="form-control" formControlName="website" placeholder="-">
                </div>

                <!-- Contact Person Name -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Contact Person Name</label>
                    <input type="text" class="form-control" formControlName="contactName" placeholder="-">
                </div>

                <!-- Email Address -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Email Address</label>
                    <input type="email" class="form-control" formControlName="email" placeholder="-">
                </div>

                <!-- Phone Number -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Phone Number</label>
                    <input type="text" class="form-control" formControlName="contactNos" placeholder="-">
                </div>

                <!-- Request Status -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Request Status</label>
                    <input type="text" class="form-control fw-semibold" formControlName="requestStatus" placeholder="-">
                </div>

                <!-- Risk Rating -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Risk Rating</label>
                    <input type="text" class="form-control" formControlName="riskRating" placeholder="-">
                </div>

                <!-- Queued For Audit -->
                <div class="col-md-6">
                    <label class="form-label small fw-semibold text-dark">Queued For Audit</label>
                    <input type="text" class="form-control" formControlName="queuedForAudit" placeholder="-">
                </div>

                <!-- Assessment Comments -->
                <div class="col-12">
                    <label class="form-label small fw-semibold text-dark">Assessment Comments</label>
                    <textarea class="form-control" formControlName="assessmentComments" rows="3" placeholder="-"></textarea>
                </div>

                <!-- Attached Documents Section -->
                @if(uploadedFiles && uploadedFiles.length > 0) {
                <div class="col-12 mt-4">
                    <label class="form-label small fw-semibold text-dark mb-2">Attached Documents</label>
                    <div class="file-list">
                        @for(file of uploadedFiles; track file){
                        <div class="file-item">
                            <div class="file-info" (click)="viewMediaFile(file)">
                                @if(file.contentType && file.contentType.includes('image')){
                                <img [src]="file.fileUrl" alt="" class="file-icon"
                                    style="max-height: 40px; max-width: 40px; object-fit: contain;">
                                }
                                @else if(file.contentType && file.contentType.includes('application/pdf')){
                                <i class="bi bi-file-earmark-pdf-fill file-icon"
                                    style="font-size: 1.5rem; color: #ef4444;"></i>
                                }
                                @else if(file.contentType && file.contentType.includes('application/msword')){
                                <i class="bi bi-file-earmark-word-fill file-icon"
                                    style="font-size: 1.5rem; color: #2b579a;"></i>
                                }
                                @else{
                                <i class="bi bi-file-earmark-text-fill file-icon"
                                    style="font-size: 1.5rem; color: #6c757d;"></i>
                                }

                                <div class="file-meta">
                                    <span class="file-name">{{file.fileName}}</span>
                                </div>
                            </div>
                            <button type="button" class="btn btn-sm btn-light text-primary fw-semibold border" (click)="viewMediaFile(file)">
                                <i class="bi bi-eye me-1"></i> View
                            </button>
                        </div>
                        }
                    </div>
                </div>
                }

                

            </div>
        </form>

    </div>
</div>